// Shared table selections may contain option objects; only explicit IDs reach AP.
export function queueParams(filters) {
    const params={};
    for(const field of ['billingaccount_ids','supplier_ids']) {
        const value=filters[field];
        if(value==null || value==='' || Array.isArray(value) && !value.length) continue;
        const entries=Array.isArray(value) ? value : String(value).split(',');
        const ids=entries.map(item=>typeof item==='object' ? item.id ?? item.value : item).map(String);
        if(ids.some(id=>!/^\d+$/.test(id) || Number(id)<1 || !Number.isSafeInteger(Number(id)))) throw new Error('Invalid AP filter selection.');
        params[field]=[...new Set(ids)].join(',');
    }
    for(const field of ['search','document_type','workflow_state','assigned_to','verdict','invoice_date_min','invoice_date_max','due_date_min','due_date_max','amount_min','amount_max','limit','offset','ordering']) {
        if(filters[field]!=null && filters[field]!=='') params[field]=filters[field];
    }
    return params;
}
